import React from 'react';
import './Forms.css';
import { Toaster } from 'react-hot-toast';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';

function openTab(tab) {
  var i;
  var x = document.getElementsByClassName("tab");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";  
  }
  document.getElementById(tab).style.display = "block";  
}

function LoginTab() {
  return (
    <div className="tab-container">
      <Toaster />
      <div className="tab-bars">
        <button className="common-button tab-single-tab" onClick={() => openTab('Login')}>Ingresar</button>
        <button className="common-button tab-single-tab" onClick={() => openTab('Signup')}>Registrarse</button>
      </div>

      <div id="Login" className="tab-content tab">
        <LoginForm />
      </div>

      <div id="Signup" className="tab-content tab" style={{display: "none"}}>
        <SignupForm />
      </div>
    </div>
  );
}

export default LoginTab;
